module.exports = __webpack_public_path__ + "img/sy.25dc98fb.png";